import { Component, PureComponent } from 'react'
import styled from 'glamorous'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { graphql } from 'react-apollo'
import { filter } from 'lodash'

import { $ } from 'utils'
import { Icon, HeaderRow, Tooltip, Loader, Button } from 'components'
import { PANEL_PERSONS } from 'queries'

import PanelSearchInput from './PanelSearchInput'
import PersonsPanelList from './PersonsPanelList'

const AnimatedContainer = styled.div({
  position: 'absolute',
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
  background: '#fff',
  zIndex: 2,
  transform: 'translateX(100%)',
  animation: 'var(--animationSlideIn)',
}, ({ shown }) => !shown && ({
  animation: 'var(--animationSlideOut)',
}), 'AddPersonsPanel')

const Container = styled.div({
  position: 'relative',
  width: '100%',
  height: '100%',
  background: 'white',
  overflow: 'hidden',
}, 'cls-container')

const MatchingContainer = styled.div({
  position: 'absolute',
  height: '100%',
  width: '100%',
}, 'cls-matchContainer')

const InputContainer = styled.div({
  marginTop: 20
})

const InnerContainer = styled(PerfectScrollbar)({
  width: '100%',
  height: '100%',
  overflowX: 'auto',
  overflowY: 'hidden',
  padding: '20px 30px',
})

const BottomBar = styled.div({
  position: 'relative',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  marginTop: 20,
})


class PanelContainer extends PureComponent {

  // todo: need fix local offset on data.variables.offset
  // https://github.com/apollographql/apollo-client/issues/2499
  componentWillMount() {
    this.setState({ offset: this.props.data.variables.offset })
  }

  componentWillReceiveProps(nextProps) {
    const { data: { persons, loading }, initialSelected, targetType, targetId,
      syncMode, syncSelected, searchItems } = nextProps
    if (loading) { return }

    if (syncMode) {
      const items = searchItems.length > 0
        ? [...persons.items, ...filter(searchItems, s => !persons.items.some(p => p.uuid === s.uuid))]
        : persons.items
      let allAttached

      if (targetType === 'list') {
        allAttached = filter(items, person =>
          person.lists.some(list => list.uuid === targetId))
      }

      if (allAttached.length > initialSelected.length) {
        const newItems = filter(allAttached, item =>
          !initialSelected.some(old => old.uuid === item.uuid))
        syncSelected(newItems)
      }
    }
  }

  fetchMore = () => {
    this.setState({ offset: this.state.offset + 1 }, () =>
      this.props.data.fetchMore({
        variables: {
          offset: this.state.offset,
        },
        updateQuery: (prev, { fetchMoreResult }) => {
          if (!fetchMoreResult) return prev
          const newItems = [...prev.persons.items, ...fetchMoreResult.persons.items]
          return {...prev, persons: { ...prev.persons, items: newItems }}
        }
      })
    )
  }

  render = () => {
    const { data: { persons, loading }, handleSubmit, handleSelect, close, selected = [],
      initialSelected = [], searchItems, handleSearch } = this.props
    if (loading && !persons) return $(Loader)
    const items = searchItems.length > 0 ? searchItems : (persons ? persons.items : [])

    return (
      $(Container,
        $(MatchingContainer,
          $(InnerContainer,
            $(HeaderRow, {
                label: 'Add Persons',
                onLabelClick: close,
                clickable: true,
                withArrow: true
              },
              $(Tooltip, {tip: 'Done'},
                $(Icon, {
                  type: 'done',
                  isDisabled: selected.length === 0 && initialSelected.length === 0,
                  isActive: selected.length > 0 || initialSelected.length > 0,
                  onClick: handleSubmit
                })
              )
            ),
            $(InputContainer, $(PanelSearchInput, { targetType: 'person', onChange: handleSearch })),
            $(PersonsPanelList, {
              items,
              selected,
              onSelect: handleSelect,
            }),
            items.length < persons.count && searchItems.length === 0 &&
            $(BottomBar,
              $(Button, {
                onClick: this.fetchMore,
                bgColor: '#9a9af2',
                primary: true,
                width: '185px',
              }, 'Show more'),
            )
          ),
        ),
      )
    )
  }
}

const options = {
  options: props => {
    return {
      fetchPolicy: 'cache-and-network',
      variables: getVariables(),
    }
  }
}
const AddPersonsPanelGql = graphql(PANEL_PERSONS, options)(PanelContainer)


class AddPersonsPanel extends Component {

  state = {
    selected: this.props.selected || [],
    initialSelected: this.props.selected || [],
    searchItems: [],
    shown: true
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selected) {
      this.setState({selected: nextProps.selected})
    }
  }

  syncSelected = (newItems) => {
    this.setState({
      initialSelected: this.state.initialSelected.concat(newItems),
      selected: this.state.selected.concat(newItems)
    })
  }

  close = () => {
    this.setState({ shown: false })
    setTimeout(() => { this.props.onClose() }, 300)
  }

  handleSubmit = () => {
    this.props.onSubmit(this.state.selected)
    this.close()
  }

  handleSyncSubmit = () => {
    const { selected, initialSelected } = this.state
    const detach = filter(initialSelected, item =>
      !selected.some(s => s.uuid === item.uuid))
    const attach = filter(selected, s =>
      !initialSelected.some(item => item.uuid === s.uuid))
    this.props.onSubmit(detach, attach)
    this.close()
  }

  handleSelect = (person) => {
    const { selected } = this.state
    const { single } = this.props
    if (!selected.find(l => l.uuid === person.uuid))
      this.setState({ selected: (single) ? [person] : selected.concat(person) })
    else
      this.setState({ selected: selected.filter(l => person.uuid !== l.uuid) })
  }

  handleSearch = (item) => {
    const { searchItems } = this.state
    if (!searchItems.find(s => s.uuid === item.uuid)) {
      this.setState({ searchItems: searchItems.concat(item) })
    }
  }

  render = () => {
    const { syncMode, targetType, targetId } = this.props
    const { selected, initialSelected, searchItems, shown } = this.state

    return (
      $(AnimatedContainer, { shown },
        $(AddPersonsPanelGql, {
          handleSubmit: syncMode ? this.handleSyncSubmit : this.handleSubmit,
          handleSelect: this.handleSelect,
          close: this.close,
          selected,
          initialSelected,
          syncMode,
          targetType,
          targetId,
          syncSelected: this.syncSelected,
          searchItems,
          handleSearch: this.handleSearch
        })
      )
    )
  }
}

export default AddPersonsPanel

const getVariables = (queryParams = {}) => ({
  limit: queryParams.limit || 7,
  offset: queryParams.offset || 1,
})



// WEBPACK FOOTER //
// ./src/components/panels/AddPersonsPanel.js